module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7nEAIf/tc-custom/9781452108414.jpg?1721404776826",
      "alt": "This image is the cover for the book Poulet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Poulet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“The humble and incredibly versatile chicken gets its due in [this] compact but thorough handbook on all things bird” by the acclaimed cookbook author (Stan Sagner, "), _c('i', [_vm._v("New York Daily News")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Poulet is more than just a cookbook dedicated to chicken: it is an ode to this worldwide favorite. More than fifty thoughtful recipes cover the globe to breathe new life into the well-loved chicken supper."), _c('br'), _c('br'), _vm._v("Five chapters are organized by flavor profile—American, Bistro, Latin, East and South Asian, and North African/Mediterranean—to bring to the table wherever you live. Each recipe is organized into a set matching a main course of chicken with a complementary grain, salad, vegetable, or bread."), _c('br'), _c('br'), _vm._v("Author Cree LeFavour’s sophistication and humor, coupled with wine, cocktail, and beer suggestions, spark a new appreciation of a time-honored favorite.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cree LeFavour, France Ruffenach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cree LeFavour is a cookbook writer who grew up on a ranch in Idaho. Her books include The New Steak (2008). She lives with her two children, Penn and Harriet, and her husband, Dwight Garner, in Frenchtown New Jersey.France Ruffenach is a San Francisco-based photographer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0